"use strict";
/* Form submission handler */ var form = document.querySelector("#form");
form.addEventListener("submit", function(e) {
    e.preventDefault();
    window.alert("Thank you! The form has been successfully submitted!");
    form.reset();
});
/* Reveal animation */ var fadeElements = document.querySelectorAll(".fade-in");
var observerOptions = {
    root: null,
    rootMargin: "0px",
    threshold: 0.15
};
var fadeObserver = new IntersectionObserver(function(entries, observer) {
    entries.forEach(function(entry) {
        if (entry.isIntersecting) {
            entry.target.classList.add("visible");
            observer.unobserve(entry.target);
        }
    });
}, observerOptions);
fadeElements.forEach(function(element) {
    fadeObserver.observe(element);
});

//# sourceMappingURL=index.cb69092b.js.map
